import { Box, Button, Flex, useColorModeValue } from "@chakra-ui/react";
import { useSelector } from "react-redux";

function Footer({ step, handleCloseForm, handleBack, handleNext, forms, campaignData, canPublish, onPublishCampaign, adsetsData, isPublishing }) {

  const userInfo = useSelector((state) => state.auth?.userInfo);
  const borderColor = useColorModeValue("gray.200", "purple.800");

  return (
    <Flex width="100%" alignItems="center" justifyContent="space-between" borderTop="1px solid" borderColor={borderColor} px={"20px"} py={2}>
      <Box>
        <Button onClick={handleCloseForm} variant="outline" backgroundColor="transparent" size={"sm"}>
          Close
        </Button>
      </Box>
      <Flex gap={"10px"}>
        {step > 0 && (
          <Button onClick={handleBack} variant="outline" backgroundColor="transparent" size={"sm"}>
            Back
          </Button>
        )}
        {step < forms?.length - 1 ? (
          <Button onClick={handleNext} colorScheme="brand" size={"sm"} isDisabled={step === 1 && (campaignData?.adsets?.length === 0 || adsetsData?.data.length === 0)}>
            Next
          </Button>
        ) : (
          <Button colorScheme="brand" size={"sm"} isLoading={isPublishing} onClick={onPublishCampaign} isDisabled={!canPublish || userInfo?.role !== "client"}>
            Publish
          </Button>
        )}
      </Flex>
    </Flex>
  );
}

export default Footer;
